import React, { useContext, useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import "./Basket.scss";
import FormStepTwo from "./FormStepTwo";
import CardItemContext from "../../../../context/CardItem/CardItemContext";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const BasketHeader = () => {
  const { basketData, activeStep, getItemCountProductPrice } =
    useContext(CardItemContext);
  //نمایش محتوای داخل سبد خرید بر اساس استپ
  //اگر استپ 1 باشد محصولات انتخاب شده نمایش داده میشود و اگر 2 باشد فرمی برای وارد کردن اطلاعات
  // shFazeli 1402/04/26

  const emptyForm = {
    fullname: "",
    address: "",
    mobile: "",
    tell2: "",
    zipCode: "",
  };
  const schema = yup
    .object({
      fullname: yup.string().required("نام و نام خانوادگی را پر کنید."),
      address: yup.string().required("آدرس را پر کنید."),
      mobile: yup
        .string()
        .test("mobile", "موبایل خود را به درستی وارد کنید.", (value) => {
          if (value.length < 11) return false;
          return true;
        }),
      tell2: yup.string().notRequired(),
      zipCode: yup
        .string()
        .test("zipCode", "کد پستی خود را درست وارد کنید.", (value) => {
          if (value.length < 10) return false;
          return true;
        }),
    })
    .required();
  const formController = useForm({
    resolver: yupResolver(schema),
    values: { ...emptyForm },
    resetOptions: {
      keepErrors: true,
    },
  });

  return (
    <div
      className="basket basket-content font-14-500"
    >
      <div className="steps flex-column flex-sm-row">
        <div
          className={`d-flex justify-content-center align-items-center col-12 col-sm-6 step first ${activeStep === 1 ? "activeStep" : ""
            }`}
        >
          <span className="numbers wh-24 d-flex justify-content-center align-items-center">
            1
          </span>
          <span>بررسی محصولات</span>
        </div>
        <div
          className={`d-flex justify-content-center align-items-center col-12 col-sm-6 step second ${activeStep === 2 ? "activeStep" : ""
            }`}
        >
          <span className="numbers wh-24 d-flex justify-content-center align-items-center">
            2
          </span>
          <span>ثبت نهایی</span>
        </div>
      </div>
      {activeStep === 1 ? (
        <div className="row justify-content-center d-flex align-items-center m-0">
          {basketData?.list?.length > 0 ? (
            basketData?.list?.map((value, index) => {
              return <ProductCard item={value} key={index} />;
            })
          ) : (
            <span className="mt-2 text-center" style={{ color: "darkgray" }}>
              سبد خرید شما فعلا خالی می باشد.
            </span>
          )}
        </div>
      ) : (
        <div>
          <FormStepTwo formController={formController} />
        </div>
      )}
    </div>
  );
};

export default BasketHeader;
